<template>
    <div class="A4">
        <div class="row">
            <div class="col-sm-12">
                <div class="print-header">
                    <h4 class="text-center font-m">{{$t('sale_summary')}}</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-striped table-sm no-bor">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                            <th>{{$t('transaction')}}</th>
                            <th class="text-right">{{$t('amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="text-center">1</td>
                            <td>{{$t('total_sale_amount')}}</td>
                            <td class="text-right">{{$money(summary.TotalAmount)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">3</td>
                            <td>{{$t('total_sale_cost_amount')}}</td>
                            <td class="text-right">{{$money(summary.TotalCost)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">2</td>
                            <td>{{$t('total_sale_receipt_amount')}}</td>
                            <td class="text-right">{{$money(summary.TotalReceipt)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">3</td>
                            <td>{{$t('total_sale_return')}}</td>
                            <td class="text-right">{{$money(summary.TotalReturn)}}</td>
                        </tr>
                        <tr>
                            <td class="text-center">4</td>
                            <td>{{$t('total_sale_ar_amount')}}</td>
                            <td class="text-right">{{$money(summary.TotalAR)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="2" class="text-right">{{$t('gross_profit')}}</th>
                            <th class="text-right">{{$money(summary.GrossProfit)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                query: {
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1,
                },
                summary: {}
            }
        },
        created(){
            let linkQuery = this.$route.query;
            if(linkQuery.year != undefined && linkQuery.year != null && linkQuery.year != ''){
                this.query.Year = linkQuery.year;
            }
            if(linkQuery.month != undefined && linkQuery.month != null && linkQuery.month != ''){
                this.query.Month = linkQuery.month;
            }
            this.toList();
        },
        methods: {
            toList: function(){
                var self = this;
                var loading = self.$loading.show();
                self.$api().post('report/sale/summaries', this.query).then(res => {
                    if(self.$isValid(res)){
                        this.summary = res.data.Json.Summary;
                    }
                }).finally(function() { loading.hide(); });
            },
        }
    }
</script>